import styled from 'styled-components'

export const Container = styled.div`
  padding: 20px;
  > .top {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  > .table {
    margin-top: 20px;
  }
`

export const DrawerSection = styled.div`
  margin-bottom: 24px;

  h4 {
    margin: 0 0 8px;
    font-size: 14px;
    color: #1f2937;
  }

  .row {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    border-bottom: 1px solid #f3f4f6;
    font-size: 13px;
    color: #4b5563;

    > span:first-child {
      color: #6b7280;
    }
    > span:last-child {
      font-family:
        ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
      color: #111827;
      max-width: 280px;
      word-break: break-all;
      text-align: right;
    }
  }
`

export const ActionRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  flex-wrap: wrap;
`

export const BatchCard = styled.div`
  margin-top: 16px;
  padding: 16px 20px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;

  > .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  .muted {
    color: #9ca3af;
    font-size: 12px;
  }
  > .steps {
    margin-top: 16px;
  }
  > .stats {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 32px;
    margin-top: 16px;

    > div {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
    .label {
      color: #6b7280;
      font-size: 12px;
    }
    .value {
      font-size: 16px;
      font-weight: 600;
      color: #111827;
    }
    .value.danger {
      color: #dc2626;
    }
    .value.mono {
      font-weight: 400;
    }
  }
  > .hint {
    margin-top: 12px;
    color: #6b7280;
    font-size: 12px;
  }
`
